import axios, { AxiosResponse } from 'axios'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

interface IFetchFeatureFlagParams {
  flag: string
  specialCase: string
}

interface IFeatureFlag {
  isActive: boolean
}

export const fetchFeatureFlag = async (params: IFetchFeatureFlagParams): Promise<IFeatureFlag> => {
  const response = await axios.get(`${hstoryAPI}/feature-flag`, {
    params: params
  })
  const { data }: AxiosResponse<IFeatureFlag> = response
  return data
}
